import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=764d86a0&scoped=true"
import script from "./Id.vue?vue&type=script&lang=js"
export * from "./Id.vue?vue&type=script&lang=js"
import style0 from "./Id.vue?vue&type=style&index=0&id=764d86a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d86a0",
  null
  
)

export default component.exports